export default "__VITE_ASSET__Bg45sGzp__"